var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-2"},[(_vm.section)?_c('StudentCarousel',{attrs:{"section_id":_vm.section.id},on:{"student_selcted":_vm.slotStudentSelected}}):_vm._e(),_c('div',[(_vm.questionTest)?[_c('TestContainer',{attrs:{"question_test_id":_vm.questionTest.id,"student_id":_vm.selected_student_id}})]:_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }